import ProjectsCard from '@pages/Manage/components/ProjectsCard.tsx';

export const ProjectsWidget = () => <ProjectsCard headDivider />;

export default ProjectsWidget;
